import React, { createContext, useContext, useState } from "react";


const AppContext = createContext();
export const useAppContext = () => useContext(AppContext);


export const AppProvider = ({ children }) => {
  const [exhibition, setExhibition] = useState(null);
  const [pavCode, setPavCode] = useState(null);
  const [standCode, setStandCode] = useState(null);

  return (
    <AppContext.Provider
      value={{ exhibition, setExhibition, pavCode, setPavCode, standCode, setStandCode }}
    >
      {children}
    </AppContext.Provider>
  );
};